import {useTranslation} from 'react-i18next';
import {resolvePrivacyPolicyLink} from '@chekin/shared/guest-form';
import {useFetchPrivacyPolicySettings} from './useFetchPrivacyPolicySettings';

type Props = {
  housingId?: string;
};

function usePrivacyPolicyLink({housingId}: Props = {}) {
  const {t} = useTranslation();
  const {hasCustomPrivacyPolicy, documentDownload, isLoading} =
    useFetchPrivacyPolicySettings({housingId});

  return resolvePrivacyPolicyLink({
    hasCustomPrivacyPolicy,
    documentDownload,
    isLoading,
    defaultHref: t('guest_privacy_policy_link'),
  });
}

export {usePrivacyPolicyLink};
